import { get } from 'src/api/api';

import { useMutation, useQuery } from '@tanstack/react-query';

import { configQueries, CONFIG_URI, type ConfigAuth } from '@/api/queryKeys';

const useGetConfig = () => {
  return useQuery({
    ...configQueries.config(),
    staleTime: Infinity,
  });
};

const useGetConfigAuth = () => {
  const hostname = window.location.hostname;
  const subdomain = hostname.split('.')[0];

  return useQuery({
    ...configQueries.auth(subdomain),
    retry: 1,
    staleTime: 1000 * 60,
  });
};

const useGetConfigAuthByClient = () => {
  return useMutation({
    mutationFn: async (client?: string) => {
      if (!client) {
        return;
      }

      const response = await get<ConfigAuth>({ uri: `${CONFIG_URI}/auth/${client}` });
      return response.data;
    },
  });
};

export { useGetConfig, useGetConfigAuth, useGetConfigAuthByClient };
